import { useAuth } from "../contexts/AuthContext";

export function useWhatsAppAccountCheck() {
  const context = useAuth();
  const user = context?.auth?.user;
  const anyEnabled = Boolean(user?.whatsapp_enabled);
  const enabledIds = Array.isArray(user?.whatsapp_enabled_account_ids) ? user.whatsapp_enabled_account_ids : [];
  return (accountId = null) =>
    anyEnabled && (accountId == null || enabledIds.some((id) => Number(id) === Number(accountId)));
}

export default function useWhatsAppEnabled(accountId = null) {
  const isEnabledFor = useWhatsAppAccountCheck();
  return isEnabledFor(accountId);
}
